module.exports = {
      id: "question-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "sprite-cf06a78a529f202f84d8278143efff12.svg#question",
      toString: function () {
        return this.url;
      }
    }